/**
 * Recuperación de contraseña de MyBarceló.
 *
 * Vive aparte de mybarcelo-auth.js, que ya tiene 1.088 líneas: meter esto
 * dentro lo dejaría cerca de 1.500 y dejaría de caber de una sentada.
 *
 * Reutiliza el conmutador de secciones del modal alternando la clase d-none
 * sobre .mybarcelo-modal__section, igual que hace MyBarceloModal.switchTab().
 */
(function () {
  'use strict';

  var CONFIG = window.myBarceloConfig || {};

  // Los mensajes vienen de PHP (wp_localize_script) para que WPML pueda
  // traducirlos: un literal aquí dentro se quedaría en inglés para siempre.
  // Los textos de reserva solo se usan si el localize fallara.
  var I18N = window.bexForgotI18n || {};

  function t(clave, reserva) {
    return I18N[clave] || reserva;
  }

  var BexForgotPassword = {

    modal: null,
    email: '',            // el correo con el que se pidió el código
    recaptchaReady: null, // promesa de carga, para no cargar el script dos veces
    temporizador: null,   // cuenta atrás del reenvío
    codigo: null,         // componente de las seis casillas (mybarcelo-ui.js)
    politica: null,       // componente de la política de contraseña

    init: function () {
      this.modal = document.getElementById('mybarcelo-modal');
      if (!this.modal) return;

      var self = this;

      // Enlaces que solo cambian de sección.
      this.modal.querySelectorAll('[data-goto]').forEach(function (el) {
        el.addEventListener('click', function () {
          self.goTo(el.getAttribute('data-goto'));
        });
      });

      var cajas = this.modal.querySelectorAll('[data-forgot="code-boxes"] input');
      if (cajas.length) {
        this.codigo = window.BexMybUi.crearComponenteCodigo({
          cajas: cajas,
          tipo: 'alfanumerico',
          alCambiar: function (delUsuario) {
            if (delUsuario) self.limpiarError('code-error');
            self.refrescarBotonCambiar();
          }
        });
      }

      this.politica = window.BexMybUi.crearPoliticaContrasena({
        input: document.getElementById('mybarcelo-forgot-password'),
        lista: this.modal.querySelector('[data-forgot="policy"]'),
        ojo: this.modal.querySelector('[data-forgot="toggle-password"]'),
        alCambiar: function (delUsuario) {
          if (delUsuario) self.limpiarError('code-error');
          self.refrescarBotonCambiar();
        }
      });

      this.initPasoCorreo();
      this.initPasoCodigo();
      this.initReenvio();
      this.initEdicionCorreo();
      this.initVueltaAlLogin();
      this.initReinicioAlCerrar();
      this.ajustarVisibilidadEnlace();
    },

    /** Cambia de sección dentro del modal y lleva el foco al primer campo útil. */
    goTo: function (name) {
      var secciones = this.modal.querySelectorAll('.mybarcelo-modal__section');

      secciones.forEach(function (s) {
        s.classList.toggle('d-none', s.dataset.section !== name);
      });

      // Al volver al login se recomprueba la sesión: puede haber cambiado desde
      // que se cargó la página.
      if (name === 'login') {
        this.ajustarVisibilidadEnlace();
      }

      var activa = this.modal.querySelector('.mybarcelo-modal__section:not(.d-none)');
      if (!activa) return;

      var foco = activa.querySelector('input:not([type="hidden"]), button:not([disabled])');
      if (foco) foco.focus();
    },

    /** Carga el script de reCAPTCHA v3 una sola vez, y en diferido. */
    loadRecaptcha: function () {
      if (this.recaptchaReady) return this.recaptchaReady;

      var key = CONFIG.recaptchaKey || '';

      if (!key) {
        this.recaptchaReady = Promise.reject(new Error('sin site key de reCAPTCHA'));
        return this.recaptchaReady;
      }

      this.recaptchaReady = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = 'https://www.google.com/recaptcha/api.js?render=' + encodeURIComponent(key);
        s.async = true;
        s.onload = function () {
          if (window.grecaptcha && window.grecaptcha.ready) {
            window.grecaptcha.ready(resolve);
          } else {
            reject(new Error('grecaptcha no disponible'));
          }
        };
        s.onerror = function () { reject(new Error('no se pudo cargar reCAPTCHA')); };
        document.head.appendChild(s);
      });

      return this.recaptchaReady;
    },

    /**
     * Un token nuevo justo antes de cada llamada: los de v3 caducan a los 2
     * minutos y son de un solo uso.
     */
    getRecaptchaToken: function (action) {
      // En modo simulado no hay llamada real, así que tampoco token.
      if (CONFIG.simulated) return Promise.resolve('simulado');

      return this.loadRecaptcha().then(function () {
        return window.grecaptcha.execute(CONFIG.recaptchaKey, { action: action });
      });
    },

    /** POST al proxy. Siempre resuelve: el proxy nunca devuelve WP_Error. */
    post: function (ruta, datos) {
      return fetch(CONFIG.restBase + '/mybarcelo/forgot-password/' + ruta, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(datos)
      }).then(function (resp) {
        return resp.json();
      });
    },

    // --- Paso 1: el correo ---

    initPasoCorreo: function () {
      var self = this;
      var form = this.modal.querySelector('[data-forgot="email-form"]');
      if (!form) return;

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var input = document.getElementById('mybarcelo-forgot-email');
        var email = (input.value || '').trim();

        if (!self.esCorreoValido(email)) {
          self.mostrarError('email-error', t('invalidEmail', 'Enter a valid email address.'));
          return;
        }

        self.sendInit(email, 'email-error', form.querySelector('[data-forgot="email-submit"]'));
      });
    },

    esCorreoValido: function (email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },

    /**
     * INITIALIZE: pide el código. Lo usan tres botones — "Recuperar contraseña",
     * "Solicitar un nuevo código" y "Guardar y enviar código".
     */
    sendInit: function (email, campoError, boton) {
      var self = this;

      this.bloquear(boton, true);

      return this.getRecaptchaToken('forgot_password')
        .then(function (token) {
          return self.post('init', { email: email, recaptcha: token });
        })
        .then(function (data) {
          self.bloquear(boton, false);

          if (data.status === 'success' && data.status_code === 'otp_sent') {
            self.email = email;
            self.alEnviarCodigo();
            return true;
          }

          // No hay rama de "cuenta no encontrada": el endpoint devuelve otp_sent
          // exista o no la cuenta (comprobado contra PRE el 11-08-2026). Los
          // códigos conocidos se explican; el resto cae en genérico a propósito,
          // para que una caída de CIAM no se cuente como otra cosa.
          if (data.status_code === 'invalid_email') {
            self.mostrarError(campoError, t('invalidEmail', 'Enter a valid email address.'));
            return false;
          }

          self.mostrarError(campoError, t('genericError', 'We could not process your request. Please try again in a few minutes.'));
          return false;
        })
        .catch(function () {
          self.bloquear(boton, false);
          self.mostrarError(campoError, t('genericError', 'We could not process your request. Please try again in a few minutes.'));
          return false;
        });
    },

    /**
     * Tras un INITIALIZE correcto desde el paso del correo. Los reenvíos y la
     * edición no pasan por aquí: gestionan su propio aviso.
     */
    alEnviarCodigo: function () {
      this.pintarCorreoActual();
      if (this.codigo) this.codigo.limpiar();
      this.goTo('forgot-code');
      this.arrancarCooldown(60);
    },

    /** El botón solo se activa con el código completo y las tres reglas cumplidas. */
    refrescarBotonCambiar: function () {
      var boton = this.modal.querySelector('[data-forgot="code-submit"]');
      if (!boton) return;

      boton.disabled = !(this.codigo && this.codigo.completo() && this.politica.ok());
    },

    // --- Paso 2: código y contraseña ---

    initPasoCodigo: function () {
      var self = this;
      var form = this.modal.querySelector('[data-forgot="code-form"]');
      if (!form) return;

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var input = document.getElementById('mybarcelo-forgot-password');
        var boton = form.querySelector('[data-forgot="code-submit"]');

        // El botón ya está deshabilitado sin esto; es el cinturón.
        if (!self.codigo.completo() || !self.politica.ok()) {
          return;
        }

        self.limpiarError('code-error');
        self.bloquear(boton, true);

        self.post('change', {
          email: self.email,
          password: input.value,
          otp: self.codigo.leer()
        }).then(function (data) {
          self.bloquear(boton, false);

          if (data.status === 'success' && data.status_code === 'success') {
            self.politica.reiniciar();
            self.codigo.limpiar();
            self.goTo('forgot-done');
            return;
          }

          // CIAM valida el código ANTES que la contraseña (comprobado: con una
          // contraseña de 3 caracteres devuelve invalid_otp, no error de
          // contraseña). Así que un invalid_otp significa código equivocado y el
          // bueno sigue vivo: se puede reintentar sin pedir otro.
          if (data.status_code === 'invalid_otp' || data.status_code === 'invalid_otp_format') {
            self.mostrarError('code-error', t('wrongCode', 'That code is not correct. Check your email and try again.'));
            self.codigo.limpiar();
            return;
          }

          if (data.status_code === 'invalid_password') {
            self.mostrarError('code-error', t('weakPassword', 'That password does not meet the requirements.'));
            return;
          }

          // Cualquier otra cosa: no sabemos si el código ha quedado gastado, así
          // que se empuja a pedir uno nuevo en vez de invitar a reintentar.
          self.mostrarError('code-error', t('changeFailed', 'We could not change your password. Request a new code and try again.'));
          self.codigo.limpiar();
        }).catch(function () {
          self.bloquear(boton, false);
          self.mostrarError('code-error', t('changeFailed', 'We could not change your password. Request a new code and try again.'));
        });
      });
    },

    // --- Reenvío del código ---

    initReenvio: function () {
      var self  = this;
      var boton = this.modal.querySelector('[data-forgot="resend"]');
      if (!boton) return;

      boton.addEventListener('click', function () {
        self.limpiarError('code-error');

        self.sendInit(self.email, 'code-error', boton).then(function (ok) {
          if (ok) {
            self.mostrarAvisoEnviado(t('newCodeSent', 'New code sent'));
            self.codigo.limpiar();
          }
        });
      });
    },

    /**
     * 60 segundos entre reenvíos, con cuenta atrás visible. Sin esto, el botón
     * es una forma cómoda de mandar correos en bucle.
     */
    arrancarCooldown: function (segundos) {
      var boton = this.modal.querySelector('[data-forgot="resend"]');
      if (!boton) return;

      if (this.temporizador) {
        clearInterval(this.temporizador);
      }

      var original = boton.getAttribute('data-label') || boton.textContent.trim();
      boton.setAttribute('data-label', original);

      var quedan = segundos;
      boton.disabled = true;
      boton.textContent = original + ' (' + quedan + ')';

      this.temporizador = setInterval(function () {
        quedan--;
        if (quedan <= 0) {
          clearInterval(this.temporizador);
          boton.disabled = false;
          boton.textContent = original;
          return;
        }
        boton.textContent = original + ' (' + quedan + ')';
      }.bind(this), 1000);
    },

    mostrarAvisoEnviado: function (titulo) {
      var aviso    = this.modal.querySelector('[data-forgot="sent-notice"]');
      var tituloEl = this.modal.querySelector('[data-forgot="sent-title"]');

      if (tituloEl) tituloEl.textContent = titulo;
      if (aviso) aviso.classList.remove('d-none');

      this.arrancarCooldown(60);
    },

    // --- Edición del correo ---

    initEdicionCorreo: function () {
      var self     = this;
      var vista    = this.modal.querySelector('[data-forgot="card-view"]');
      var form     = this.modal.querySelector('[data-forgot="edit-form"]');
      var editar   = this.modal.querySelector('[data-forgot="edit-email"]');
      var cancelar = this.modal.querySelector('[data-forgot="edit-cancel"]');
      var input    = document.getElementById('mybarcelo-forgot-new-email');
      if (!form || !editar) return;

      editar.addEventListener('click', function () {
        // Relleno con el correo actual, para corregir una errata sin
        // reescribirlo entero.
        if (input) input.value = self.email;
        vista.classList.add('d-none');
        form.classList.remove('d-none');
        if (input) input.focus();
      });

      if (cancelar) {
        cancelar.addEventListener('click', function () {
          form.classList.add('d-none');
          vista.classList.remove('d-none');
        });
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var nuevo = (input.value || '').trim();
        var boton = form.querySelector('[data-forgot="edit-save"]');

        if (!self.esCorreoValido(nuevo)) {
          self.mostrarError('code-error', t('invalidEmail', 'Enter a valid email address.'));
          return;
        }

        // Otro correo es otro username: el código anterior deja de servir, así
        // que esto es un INITIALIZE nuevo.
        self.sendInit(nuevo, 'code-error', boton).then(function (ok) {
          if (!ok) return;

          form.classList.add('d-none');
          vista.classList.remove('d-none');
          self.pintarCorreoActual();
          self.codigo.limpiar();
          self.mostrarAvisoEnviado(t('emailUpdated', 'Email updated and code sent'));
        });
      });
    },

    pintarCorreoActual: function () {
      var el = this.modal.querySelector('[data-forgot="current-email"]');
      if (el) el.textContent = this.email;
    },

    // --- Remates ---

    /**
     * El enlace de recuperación no se ofrece con la sesión abierta: recuperar
     * la contraseña estando dentro es otro flujo y otra llamada.
     */
    ajustarVisibilidadEnlace: function () {
      // Lo llama también mybarcelo-auth al cambiar la sesión, quizá antes del init.
      if (!this.modal) return;
      var enlace = this.modal.querySelector('.mybarcelo-modal__forgot');
      if (!enlace) return;

      var indicador = document.getElementById('mybarcelo-login');
      var logueado  = !!(indicador && indicador.dataset.mybarceloState === 'logged');

      enlace.classList.toggle('d-none', logueado);
    },

    /**
     * Cerrar el modal descarta el estado del flujo. El código llega por correo,
     * así que volver a empezar cuesta poco y no merece persistirlo.
     */
    initReinicioAlCerrar: function () {
      var self = this;

      var cerrar   = this.modal.querySelector('.mybarcelo-modal__close');
      var backdrop = this.modal.querySelector('.mybarcelo-modal__backdrop');

      [cerrar, backdrop].forEach(function (el) {
        if (el) el.addEventListener('click', function () { self.reiniciar(); });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') self.reiniciar();
      });
    },

    reiniciar: function () {
      this.email = '';

      if (this.temporizador) {
        clearInterval(this.temporizador);
        this.temporizador = null;
      }

      var correo = document.getElementById('mybarcelo-forgot-email');
      var nuevo  = document.getElementById('mybarcelo-forgot-new-email');

      if (correo) correo.value = '';
      if (nuevo)  nuevo.value  = '';

      // La contraseña y las reglas las reinicia el propio componente.
      if (this.codigo) this.codigo.limpiar();
      if (this.politica) this.politica.reiniciar();

      this.limpiarError('email-error');
      this.limpiarError('code-error');

      var enviado = this.modal.querySelector('[data-forgot="sent-notice"]');
      if (enviado) enviado.classList.add('d-none');

      var editForm = this.modal.querySelector('[data-forgot="edit-form"]');
      var cardView = this.modal.querySelector('[data-forgot="card-view"]');
      if (editForm) editForm.classList.add('d-none');
      if (cardView) cardView.classList.remove('d-none');

      var resend = this.modal.querySelector('[data-forgot="resend"]');
      if (resend) {
        resend.disabled = false;
        var etiqueta = resend.getAttribute('data-label');
        if (etiqueta) resend.textContent = etiqueta;
      }

      this.goTo('login');
    },

    /**
     * Al volver al login desde "contraseña actualizada", el correo va relleno:
     * el cambio de contraseña no devuelve tokens, así que hay que iniciar sesión
     * a mano y no tiene sentido hacer teclearlo otra vez.
     */
    initVueltaAlLogin: function () {
      var self  = this;
      var boton = this.modal.querySelector('[data-section="forgot-done"] [data-goto="login"]');
      if (!boton) return;

      boton.addEventListener('click', function () {
        var login = document.getElementById('mybarcelo-email');
        if (login && self.email) login.value = self.email;
      });
    },

    mostrarError: function (nombre, mensaje) {
      var el = this.modal.querySelector('[data-forgot="' + nombre + '"]');
      if (!el) return;
      el.textContent = mensaje;
      el.classList.remove('d-none');
    },

    limpiarError: function (nombre) {
      var el = this.modal.querySelector('[data-forgot="' + nombre + '"]');
      if (!el) return;
      el.textContent = '';
      el.classList.add('d-none');
    },

    bloquear: function (boton, activo) {
      if (!boton) return;
      boton.disabled = activo;
      boton.classList.toggle('is-loading', activo);
    }
  };

  window.BexForgotPassword = BexForgotPassword;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { BexForgotPassword.init(); });
  } else {
    BexForgotPassword.init();
  }
})();
